<template>
  <div class="PurchaseAgreementCreation">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <!-- 表单区域 -->
          <!-- <formItem
            ref="formItem"
            :params="baseFormData"
            :columns="formColumList"
            :rules="computedFormRule"
            @changeValueHandler="changeValueHandler"
            labelWidth="120px"
            :disabledForm="isDisabledForm"
          >
          </formItem> -->
          <SiruiSearch
            ref="formItem"
            :query="baseFormData"
            :columns="formColumList"
            :isQueryPanel="false"
            :rules="computedFormRule"
            @changeMethod="changeMethod"
            :isDisabledForm="isDisabledForm"
          >
          </SiruiSearch>
        </div>
      </el-collapse-item>
      <!--产品明细-->
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            交易明细
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs type="card" v-model="tabActiveName" class="common-tab">
            <el-tab-pane label="产品明细" name="first">
              <div class="detail">
                <!-- 协议的时候显示 -->
                <AgreementTable
                  ref="orderDetailListRef"
                  :defaultTableData="orderDetailList"
                  :baseFormData="baseFormData"
                  :detailPageData="detailPageData"
                  :fileType="fileType"
                  @closeTableHandler="closeTableHandler"
                  @isDisabledIsRestrict="isDisabledIsRestrict"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="关联明细" name="seconed">
              <div class="detail">
                <RelationInfoTable
                  :isEdit="isEdit"
                  ref="relationInfo"
                  :defaultData="orderContractRelationshipList"
                ></RelationInfoTable>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>

      <!--附件-->
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <!-- <FileTable ref="fileTableRef" :attachments="attachments" :isShowDownBtn="isShowDownBtn" /> -->
          <IEUploadFileType
            ref="fileTableRef"
            :tableData="attachments || []"
            @upload="handleUpload"
            :isShowDownBtn="isShowDownBtn"
            dictType="CONTRACT_INITIATION"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮组 -->
    <AgreementBtn :contractStatus="contractStatus" @btnHandler="btnGroupHandler" />
  </div>
</template>
<script>
  // import formItem from '../components/form-item';
  import RelationInfoTable from './components/RelationInfoTable/index.vue';
  import purchaseAgreementCreationMixin from './purchaseAgreementCreationMixin.js';
  import purchaseEditFormFieldMixin from './purchaseEditFormFieldMixin.js';
  import purchaseTrimFormFieldMixin from './purchaseTrimFormFieldMixin.js';
  import AgreementTable from './components/AgreementTable/index.vue';
  import AgreementBtn from './components/FooterBtnGroup/AgreementBtn.vue';
  import { baseFormColum, formRule } from './contractForm.js';
  export default {
    name: 'purchaseAgreementCreation',
    components: {
      // formItem,
      RelationInfoTable,
      AgreementTable,
      AgreementBtn,
    },
    mixins: [
      purchaseTrimFormFieldMixin,
      purchaseAgreementCreationMixin,
      purchaseEditFormFieldMixin,
    ],
    data() {
      return {
        isSales: false, //销售是sales，采购是purchase,标志符true代表传sales
        activeNames: ['1', '2', '3'],
        tabActiveName: 'first',
        fileType: 'agreement', // 当前是采购协议
        load: false,
      };
    },
    computed: {
      isEdit() {
        return this.$route.query?.isEdit == 'true' ? true : false;
      },
      formColumList() {
        return baseFormColum(this);
      },
      computedFormRule() {
        return formRule(this);
      },
    },
    methods: {
      isDisabledIsRestrict(isDisabled) {
        console.log(isDisabled, '是否禁用');
        this.disabledIsRestrict = isDisabled;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .prodcut {
    margin-bottom: 11px;
    background-color: #fff;
  }

  .detail {
    padding-bottom: 0px;
  }

  .collapse-main-content {
    margin-bottom: 10px;
  }
</style>
